import * as yup from "yup";
import { validation } from "formUtils/validation";
import { errorsMessage } from "formUtils/errorMessages";

export const validationSchema = yup
  .object()
  .shape({
    grandfatherOccupation: validation.stringNotRequired,
    childhoodFriendName: validation.stringNotRequired,
    partnerMeetingLocation: validation.stringNotRequired,
    parentsMeetingLocation: validation.stringNotRequired,
    preferredRetirementCity: validation.stringNotRequired,
    favoriteSportsTeam: validation.stringNotRequired,
    firstCarModel: validation.stringNotRequired,
    favoriteFood: validation.stringNotRequired,
    password: validation.passwordValidation,
    requiredCountAnswerError: yup.string().nullable(),
  })
  .test(
    "min-3-required",
    errorsMessage.required_count_security_questions,
    function (value) {
      const { createError } = this;

      const requiredFields = [
        value.grandfatherOccupation,
        value.childhoodFriendName,
        value.partnerMeetingLocation,
        value.parentsMeetingLocation,
        value.preferredRetirementCity,
        value.favoriteSportsTeam,
        value.firstCarModel,
        value.favoriteFood,
      ];

      const filledFieldsCount = requiredFields.filter(
        (field) => field != null && field !== "",
      ).length;

      if (filledFieldsCount < 3) {
        return createError({
          path: "requiredCountAnswerError",
          message: errorsMessage.required_count_security_questions,
        });
      }

      return true;
    },
  );
